import { Utils } from "@/web-framework/api/utils.js";

const CustomerAPI = {
    /**
     * @description: 查询客户
     * @param {*} query
     * @return {*}
     */
    searchCustomer(type, query) {
        type = Utils.uncapitalize(type);
        return Request.post(`/vps/customer/${type}/search`, query);
        /**
         * @description: 保存客户
         * @return {*}
         */
    },
    saveCustomer(type, data) {
        return Request.post(`/vps/customer/${type}/save`, data);
    },
    /**
     * @description: 删除客户
     * @param {*} id
     * @return {*}
     */
    removeCustomer(type, id) {
        return Request.delete(`/vps/customer/${type}/delete/${id}`);
    },
    /**
     * @description: 批量删除客户
     * @param {*} idArray
     * @return {*}
     */
    batchRemoveCustomers(type, idArray) {
        return Request.post(`/vps/customer/${type}/batchDelete`, idArray);
    },
};
export default CustomerAPI;